module.exports = __webpack_public_path__ + "img/wheelM2.c107511e.png";